import React from 'react';
import './Services.css'

const Services = () => {
    return (
        <section className="mh-service text-white pt-5">
        <div className="container">
                <h2 data-aos='fade-right'>What I do</h2>
            <div className="row" data-aos='fade-up' data-aos-duration="1000">
                <div className="col-sm-4">
                    <div className="mh-service-item">
                        <i className="fa fa-code iron-color"></i>
                        <h3>Web Development</h3>
                        <p>Web development is the building and maintenance of websites; it's the work that happens behind the scenes to make a website look great, work fast and perform well with a seamless user experience. Web developers, or 'devs', do this by using a variety of coding languages</p>
                    </div>
                </div>

                <div className="col-sm-4">
                    <div className="mh-service-item">
                        <i className="fa fa-bullseye purple-color"></i>
                        <h3>Responsive Design</h3>
                        <p>Responsive Web design is the approach that suggests that design and development should respond to the user's behavior and environment based on screen size, platform and orientation. The practice consists of a mix of flexible grids and layouts, images and an intelligent use of CSS media queries.</p>
                    </div>
                </div>

                <div className="col-sm-4">
                    <div className="mh-service-item">
                        <i className="fa fa-object-ungroup sky-color"></i>
                        <h3>App Development</h3>
                        <p>Web application development is the creation of application programs that reside on remote servers and are delivered to the user's device over the Internet. ... Client refers to a computer application such as a web browser. Client-side programming will typically utilize HTML, CSS and JavaScript.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    );
};

export default Services;